module.exports = __webpack_public_path__ + "img/picnic_inner_5.89d35768.jpg";